import { trimEndSlash } from "../helpers";
import { SEAMLESS_ANONYMOUS_ENDPOINT } from "../constants";
export class SeamlessRequestService {
    constructor(url, operatorAuthTokenId, ajaxService) {
        if (!operatorAuthTokenId) {
            throw new Error("Invalid operatorAuthTokenId");
        }
        this.baseAnynomousApiUrl = url;
        this.ajaxService = ajaxService;
        this.operatorAuthTokenId = operatorAuthTokenId;
    }
    getAnonymousToken() {
        return this.ajaxService
            .send(`${trimEndSlash(this.baseAnynomousApiUrl)}/${SEAMLESS_ANONYMOUS_ENDPOINT}`, {
            headers: {
                domainId: this.operatorAuthTokenId
            },
            method: "POST"
        })
            .then(response => {
            if (response.status < 200 || response.status > 299) {
                throw new Error(response.statusText);
            }
            return response.text();
        })
            .then(response => this.getParsedToken(response))
            .catch(err => { throw new Error(err); });
    }
    getParsedToken(response) {
        let parsedResponse = JSON.parse(response);
        return parsedResponse.jwt || parsedResponse.Jwt;
    }
}
//# sourceMappingURL=SeamlessRequestService.js.map